<template>
  <div class="content">
    <van-sticky>
      <van-tabs v-model="activetab" color="#cca352" title-active-color="#cca352" title-inactive-color="#6a6a73" background="#141414" style="margin-bottom: 10px">
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name" :name="item.id"></van-tab>
      </van-tabs>
    </van-sticky>
    <div data-v-3cb7ae5b="" class="cardsDetail" v-if="activetab == 1">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in bankInfo" :key="index">
          <div data-v-3cb7ae5b="" class="card icbc">
            <div data-v-3cb7ae5b="" class="bank">
              <p data-v-3cb7ae5b="" class="iconName">
                <img data-v-3cb7ae5b="" :src="item.bank_img" alt="" class="bankIcon" />
                <span data-v-3cb7ae5b="" class="bankName">{{ item.bank_name }}</span>
              </p>
            </div>

            <p data-v-3cb7ae5b="" class="cardNum" style="padding-left: 20px">{{ item.card_number }}</p>
            <p data-v-3cb7ae5b="" class="cardNum" style="padding-left: 20px">{{ item.branch }}</p>
            <p data-v-3cb7ae5b="" class="rt" @click="delShow(item)" style="display: none">解绑</p>
          </div>
        </li>
      </ul>

      <div data-v-3cb7ae5b="" class="methods" v-if="cardLis.length < 5" @click="$parent.goNav('/addBankCard')">
        <a data-v-3cb7ae5b="" class="addBank"
          ><div data-v-3cb7ae5b="" class="icon"></div>
          <span data-v-3cb7ae5b="" class="title">添加银行卡</span></a
        >
      </div>
    </div>
    <div data-v-3cb7ae5b="" class="cardsDetail" v-if="activetab == 2">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in walletInfo" :key="index">
          <div data-v-3cb7ae5b="" class="card icbc">
            <div data-v-3cb7ae5b="" class="bank" style="position: relative">
              <p data-v-3cb7ae5b="" class="iconName">
                <img data-v-3cb7ae5b="" :src="item.logo" alt="" class="bankIcon" />
                <span data-v-3cb7ae5b="" class="bankName">{{ item.name }}</span>
              </p>
              <p v-if="item.is_bind == 1" style="margin: 10px 0;">{{ item.address }}</p>
              <div style="position: absolute; top: 0px; right: 10px; height: 30px; line-height: 30px"><a v-if="item.is_bind == 0" @click="toBindWaller(item)">绑定</a><span v-else>{{ item.is_bind }} / 1 </span></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div data-v-3cb7ae5b="" class="cardsDetail" v-if="activetab == -1000">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in usdssLis" :key="index">
          <div data-v-3cb7ae5b="" class="card icbc">
            <div data-v-3cb7ae5b="" class="bank">
              <p data-v-3cb7ae5b="" class="iconName">
                <span data-v-3cb7ae5b="" class="bankName">{{ item.bank }}</span>
              </p>
            </div>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_owner }}</p>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_no }}</p>

            <p data-v-3cb7ae5b="" class="rt" @click="delShow(item)">解绑</p>
          </div>
        </li>
      </ul>

      <div data-v-3cb7ae5b="" class="methods" v-if="usdssLis.length < 5" @click="$parent.goNav('/addUsdtCard')">
        <a data-v-3cb7ae5b="" class="addBank"
          ><div data-v-3cb7ae5b="" class="icon"></div>
          <span data-v-3cb7ae5b="" class="title">添加USDT</span></a
        >
      </div>
    </div>
    <div data-v-710c460e="" data-v-0dc57850="" @touchmove.prevent class="popup-background" v-if="delBox.id">
      <div data-v-0dc57850="" data-v-710c460e="" class="safety-popup">
        <div data-v-0dc57850="" data-v-710c460e="" class="popup">
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-head">操作确认 <a data-v-0dc57850="" data-v-710c460e="" @click="closeDel" class="pop-close"></a></div>
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-content">
            <p data-v-0dc57850="" data-v-710c460e="">您确定要删除</p>
            <p data-v-0dc57850="" data-v-710c460e="">{{ delBox.bank_no }}-{{ delBox.bank_owner }}</p>
            <p data-v-0dc57850="" data-v-710c460e="">吗？</p>
            <a data-v-0dc57850="" data-v-710c460e="" @click="isDelOk()" class="button">立即删除</a>
          </div>
        </div>
      </div>
    </div>
    <div class="add-wallet">
      <van-popup v-model="walletshow" position="bottom" closeable round>
        <div>
          <div style="text-align: center; height: 38px; line-height: 38px; font-size: 18px; font-weight: 600; margin-top: 10px;color: #fff;">绑定{{ wallet.name }}</div>
          <van-form ref="subfrm" @submit="bandWallet">
            <div class="add-wallet-frm">
              <van-cell-group>
                <van-cell title="钱包地址">
                  <template #label>
                    <van-field v-model="address" placeholder="请输入钱包地址" :rules="[{ required: true }]" />
                  </template>
                </van-cell>
                <van-cell title="支付密码">
                  <template #label>
                    <van-field v-model="pay_pass" type="password" placeholder="请输入支付密码" :rules="[{ required: true }]" />
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
            <div style="margin: 16px">
              <van-button block native-type="submit" style="background-color: #cca352; color: #fff; border-radius: 8px; border-color: #cca352">绑定</van-button>
            </div>
          </van-form>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bankCard',
  data () {
    return {
      tabs: [
        { id: 1, name: '银行卡' },
        { id: 2, name: '钱包' },
      ],
      activetab: 1,
      usdssLis: [],
      cardLis: [],
      baseURL: '',
      delBox: {},
      walletInfo: null,
      bankInfo: null,
      wallet: {},
      walletshow: false,

        address: null,
        pay_pass: null,
    };
  },
  created () {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    if(this.$route.query.type && this.$route.query.type == 2){
      this.activetab = 2
    }
    that.gerWalletInfo();
    that.gerBankInfo();
  },
  methods: {
    toBindWaller (item) {
      this.wallet = item;
      this.frm = this.wallet.id
      this.walletshow = true
      this.address = null
      this.pay_pass = null
      this.$refs.subfrm.resetValidation()
    },
    gerWithdrawType () {
      let that = this;
      that.$apiFun.post('/api/gerWithdrawType').then(res => {
        if (res.code == 200) {
          that.withdrawType = res.data;
        }
      });
    },
    gerWalletInfo () {
      let that = this;
      that.$apiFun.post('/api/gerWalletInfo').then(res => {
        if (res.code == 200) {
          that.walletInfo = res.data;
        }
      });
    },
    gerBankInfo () {
      let that = this;
      that.$apiFun.post('/api/gerBankInfo').then(res => {
        if (res.code == 200) {
          that.bankInfo = res.data;
        }
      });
    },
    bandWallet () {
      let that = this;
      that.$apiFun.post('/api/bindWallet', {id:this.wallet.id,address:this.address,pay_pass:this.pay_pass}).then(res => {
        that.$parent.showTost(0, res.message);
        if (res.code == 200) {
          this.gerWalletInfo();
          this.walletshow = false;
          this.wallet = {};
        }
      });
    },
    /**********************************/
    getUsdssList () {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    delShow (item) {
      let that = this;
      that.delBox = item;
    },
    closeDel () {
      let that = this;
      that.delBox = {};
    },
    isDelOk () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/delcard', { id: that.delBox.id }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.$parent.showTost(1, '解绑成功');
          that.delBox = {};
          that.getcard();
          that.getUsdssList();
        }
        that.$parent.hideLoading();
      });
    },
    getcard () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted () {
    let that = this;
  },
  updated () {
    let that = this;
  },
};
</script>
<style>
.add-wallet > .van-popup {
  background: #282828 !important;
}
.add-wallet-frm > .van-cell-group > .van-cell {
  background: #282828 !important;
}
.add-wallet-frm > .van-cell-group > .van-cell::after {
  border: none;
}
.add-wallet-frm > .van-cell-group > .van-cell > .van-cell__title > .van-cell__label > .van-cell {
  background: #282828 !important;
}
.add-wallet-frm > .van-cell-group > .van-cell > .van-cell__title {
  color: #fff !important;
}
.add-wallet-frm > .van-cell-group > .van-cell > .van-cell__title > .van-cell__label > .van-cell > .van-cell__value > .van-field__body > input.van-field__control {
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
@import '../../../static/css/chunk-73f6d132.1840fe36.css';
.content .cardsDetail .cards li .card .rt[data-v-3cb7ae5b][data-v-eeb2b3bc] {
  width: 1.2rem;
  height: 0.5rem;
}
.content .cardsDetail .cards li .card .cardNum[data-v-3cb7ae5b][data-v-eeb2b3bc] {
  padding-bottom: 2px;
  padding-top: 10px;
  margin-top: 0px;
  font-size: 20px;
}
.popup-background[data-v-710c460e] {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/main/bankCard.vue